import "./ConfirmPasswordReset.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ConfirmPasswordResetComponentController } from "./ConfirmPasswordResetComponentController";

export class ConfirmPasswordResetComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = ConfirmPasswordResetComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/ResetPassword/ConfirmReset/ConfirmPasswordReset.html";
    }
}
